var map = {
	"./arbitri.png": "f0c7",
	"./classbut.png": "6b59",
	"./classcp.png": "0829",
	"./classsq.png": "a75e",
	"./confrscore.png": "015c",
	"./curriculum.png": "a123",
	"./figb.png": "aefc",
	"./incontri.png": "ea5f",
	"./inviaris.png": "cff3",
	"./mostraris.png": "859b",
	"./movim.png": "3c4c",
	"./tavolo.png": "92fa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8a78";